import React from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import { markNotificationAsSeen } from "../../client/api";
import { USER_NOTIFICATIONS } from "../../utils/utils";

const GoogleDriveAccessNotification = ({ userId, onClose }: any) => {
  const handleDismiss = async () => {
    try {
      await markNotificationAsSeen(
        userId,
        USER_NOTIFICATIONS.googleDriveAccess
      );
      onClose();
    } catch (error) {
      console.error("Error dismissing notification:", error);
    }
  };

  return (
    <Alert
      severity="success"
      action={
        <Button color="inherit" size="small" onClick={handleDismiss}>
          Dismiss
        </Button>
      }
      sx={{ mb: 2 }}
    >
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Google Drive Access Granted! 🎉
        </Typography>
        <Typography variant="body2">
          You can now upload videos directly to your Google Drive.
        </Typography>
      </Box>
    </Alert>
  );
};

export default GoogleDriveAccessNotification;
